import styled, { css } from 'styled-components'

export const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['8']};
    flex: 1;
    min-width: 0;
  `,
)

export const BackButton = styled.button<{ $isDropTarget?: boolean }>(
  ({ theme, $isDropTarget }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['4']};
    background: ${$isDropTarget ? theme.colors.blue100 : 'none'};
    border: ${theme.border.size['1']} solid
      ${$isDropTarget ? theme.colors.blue500 : theme.colors.gray400};
    border-radius: ${theme.border.radius['8']};
    padding: ${theme.space['8']} ${theme.space['12']};
    cursor: pointer;
    font-size: 1.4rem;
    white-space: nowrap;
    flex-shrink: 0;
  `,
)

export const Trail = styled.div(
  () => css`
    display: flex;
    align-items: center;
  `,
)

export const Crumb = styled.span(
  () => css`
    display: flex;
    align-items: center;
    flex: 1 1 0%;
    width: fit-content;
    max-width: 10rem;
  `,
)

export const CrumbLink = styled.span<{ $isDropTarget?: boolean }>(
  ({ theme, $isDropTarget }) => css`
    flex: 1;
    min-width: 0;
    font-size: 1.4rem;
    color: ${theme.colors.black500};
    text-decoration: underline;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: ${theme.space['4']};
    border-radius: ${theme.border.radius['4']};
    background: ${$isDropTarget ? theme.colors.blue100 : 'transparent'};
  `,
)

export const Separator = styled.span(
  ({ theme }) => css`
    margin: 0 ${theme.space['4']};
    color: ${theme.colors.black300};
    flex-shrink: 0;
  `,
)

export const CurrentFolder = styled.span(
  ({ theme }) => css`
    font-size: 1.8rem;
    font-weight: 600;
    color: ${theme.colors.black800};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 10rem;
  `,
)
